"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useJGraph = exports.JGraphContextProvider = void 0;
const react_1 = require("react");
const JGraphContext = (0, react_1.createContext)({
    scaleY: null,
    height: 0,
    maxValue: 0,
});
exports.JGraphContextProvider = JGraphContext.Provider;
function useJGraph() {
    const jGraphState = (0, react_1.useContext)(JGraphContext);
    if (!jGraphState.scaleY) {
        throw new Error('scale cannot be null');
    }
    return jGraphState;
}
exports.useJGraph = useJGraph;
